import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDetailsPipe } from './file-details.pipe';



@NgModule({
  declarations: [
    FileDetailsPipe
  ],
  imports: [
    CommonModule
  ],
  exports:[FileDetailsPipe]
})
export class FileDetailsModule { }
